var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPentagon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.01 512.01",
    viewBox: "0 0 512.01 512.01",
    style: {
      width: 30,
      height: 30
    },
    className: "shape-svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m507.804 200.28-245.333-187.414c-3.84-2.923-9.131-2.923-12.949 0l-245.334 187.414c-3.605 2.773-5.077 7.531-3.648 11.84l93.717 281.92c1.451 4.373 5.525 7.296 10.133 7.296h303.253c4.587 0 8.683-2.944 10.133-7.296l93.717-281.92c1.389-4.331-.083-9.067-3.689-11.84z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPentagon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pentagon.d0834c9b.svg";
export { ForwardRef as ReactComponent };